import { animate, style, transition, trigger } from '@angular/animations';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Toast, ToasterService } from './toaster.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toastr',
  templateUrl: './toastr.component.html',
  styleUrl: './toastr.component.css',

  animations: [
    trigger('toastAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class ToastrComponent implements OnInit, OnDestroy {

  private toasterService = inject(ToasterService);

  toasts: Toast[] = [];
  private subscription!: Subscription;

  ngOnInit(): void {
    this.subscription = this.toasterService.toasts$.subscribe(toasts => this.toasts = toasts)
  }

  ngOnDestroy(): void {
    if (this.subscription){
      this.subscription.unsubscribe()
    }
  }

  removeToast(id: number) {
    this.toasterService.remove(id)
  }

  getToastIconUrl(toastType: string): string {
    return `assets/icons/toasts/${toastType}.png`;
  }

  trackToast(index: number, toast: Toast): number {
    return toast.id;
  }

}
